import { Injectable } from '@angular/core';
import { interval, Observable, Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SessionTimerService {
  private readonly timeoutSeconds: number;
  private timerCount: number = 0;
  private timerSubscription!: Subscription;
  private timer: Observable<number> = interval(1000);
  private remainingSeconds = new Subject<number>();
  /*** Observable to get session remaining time (in seconds).*/
  remainSeconds$ = this.remainingSeconds.asObservable();

  constructor() {
    this.timeoutSeconds = Number(environment.delegateSessionTimeoutSecs);
    console.log("Timeout at - "+ this.timeoutSeconds);
  }

  startTimer() {
    this.stopTimer();
    this.timerCount = this.timeoutSeconds;
    this.timerSubscription = this.timer.subscribe(n => {
      if (this.timerCount > 0) {
        this.timerCount--;
        this.remainingSeconds.next(this.timerCount);
      }
    });
  }

  stopTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }  
}
